<template>
  <div class="signin-wrapper">
      <div class="signin-modal">
        <div class="signin-modal-top">
            <img src="../img/eflexIcon.png" alt="eflex icon">
            <p>Forgot Your Password</p>
        </div>
        <div class="signin-modal-bottom">
          <form name="form" @submit.prevent="handleForgotPassword">
            <div v-if="!successful">
              <div class="form-group">
                <label for="email">Email</label>
                <input
                  v-model="user.email"
                  v-validate="'required'"
                  type="text"
                  class="bottom-margin"
                  name="email"
                  placeholder="Enter your email."
                />
                <div
                  v-if="errors.has('email')"
                  class="alert alert-danger"
                  role="alert"
                ><font color=red>Email is required!</font></div>
              </div>
              <!-- <div>
                <button :disabled="loading">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                  <span>Reset Password</span>
                </button>
              </div> -->
              <div>
                <div class="signin-modal-bottom">
                  <button class="signin-modal-bottom">Send your email</button>
                </div>
                <!-- <div>
                  <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
                </div> -->
                <div class="already-wrapper">
                    <br>
                </div>
                <div class="already-wrapper">
                    <a href="/register">Not a memeber yet?</a>
                </div> 
              </div>
            </div>

            <!-- 
            <label for="email">Email</label>
            <input type="text" name="email" class="bottom-margin">
            <label for="password">Password</label>
            <input type="password" name="password">
            <a class="bottom-margin" href="#">Forget Password</a>
            <button>Sign In</button>
            <div class="already-wrapper">
                <a href="/register">Not a memeber yet?</a>
            </div> 
            -->
            <div class="already-wrapper">
                <br>
            </div>
            <div class="form-group">
              <div
                v-if="message"
                class="alert"
                :class="successful ? 'alert-success' : 'alert-danger'"
              >{{message}}</div>
            </div>

          </form>
        </div>
      </div>
    </div>
</template>

<script>
import User from '../models/user';

export default {

  name: 'ForgotPassword',

  data() {
    return {
      user: new User('', '', '', '', '', '', '', '', '', '', '', ''),
      submitted: false,
      successful: false,
      //loading: false,
      message: ''
    };
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },

    currentUser() {
      return this.$store.state.auth.user;
    }
  },

  created() {
    if (this.loggedIn) {
      this.$router.push('/profile');
    }
  },
  methods: {
    handleForgotPassword() {
      console.log("handleForgotPassword: ", this.user)
      //this.loading = true;
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
        /* if (!isValid) {
          this.loading = false;
          return;
        } */
          //if (this.user.email) {
            this.$store.dispatch('auth/forgotPassword', this.user).then(
              /* () => {
                this.$router.push('/login');
              }, */

              console.log("Email: ", this.user.email),
          
              data => {
                console.log("Message: ", data.message)
                this.successful = true;
                this.message = "Verification link is sent on your mail. Please check it!";
              },
              error => {
                this.message =
                  (error.response && error.response.data && error.response.data.message) ||
                  error.message ||
                  error.toString();
                this.successful = false;
              }
            );
          //}
        }
      });
    }
  },
};
</script>

<!-- 
<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style> 
-->

<style lang="scss">
@import "../sass/main.scss";

.signin-wrapper {
    min-height: 100vh;
    background: $green-background;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -100px;
}

.signin-modal {
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 0%, 0.2);
    padding: 40px;
    width: 500px;
    margin-top: -200px;
}

.signin-modal-top {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
}

.signin-modal-top img {
    width: 50px;
}

.signin-modal-bottom label {
    display: block;
    font-size: .9em;
    margin: 0 0 3px 5px;
}

.signin-modal-bottom input {
    width: 94%;
    padding: 10px 15px;
    border-radius: 10px;
    border: 1px solid #ccc;
}

.signin-modal-bottom a {
    margin-top: 5px;
    margin-left: 5px;
    font-size: .75em;
    display: inline-block;
}

.already-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    //aligin-items: center;
}

.bottom-margin {
    margin-bottom: 40px;
}

.signin-modal-bottom button{
    width: 100%;
    padding: 10px 15px;
    border-radius: 10px;
    border: none;
    background: $green2;
    color: #fff;
}

.signin-modal-bottom button:hover {
    background: hsl(144, 58%, 40%);
}


</style>